var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dsf-readfilestructure" }, [
    _c(
      "div",
      { staticClass: "item" },
      [
        _c(
          "div",
          { staticClass: "title" },
          [
            _c("i", { staticClass: "iconfont icon-wenjianjia" }),
            _c("el-input", {
              attrs: { placeholder: "路径", clearable: "", readonly: "" },
              model: {
                value: _vm.rootPath,
                callback: function ($$v) {
                  _vm.rootPath = $$v
                },
                expression: "rootPath",
              },
            }),
          ],
          1
        ),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { border: "", stripe: "", data: _vm.tableData },
          },
          [
            _c("el-table-column", {
              key: "name",
              attrs: {
                width: "auto",
                label: "名称",
                align: "left",
                prop: "name",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        {
                          class: { folder: scope.row.dir },
                          on: {
                            click: function ($event) {
                              return _vm.loadNextFile(scope.row)
                            },
                          },
                        },
                        [
                          scope.row.dir
                            ? _c("i", {
                                staticClass: "iconfont icon-wenjianjia",
                              })
                            : _vm._e(),
                          _vm._v(" " + _vm._s(scope.row.name) + " "),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              key: "size",
              attrs: {
                width: "auto",
                label: "大小",
                align: "left",
                prop: "size",
              },
            }),
            _c("el-table-column", {
              key: "type",
              attrs: {
                width: "auto",
                label: "类型",
                align: "left",
                prop: "type",
              },
            }),
            _c("el-table-column", {
              key: "modifyTime",
              attrs: {
                width: "auto",
                label: "修改时间",
                align: "left",
                prop: "modifyTime",
              },
            }),
            _c("el-table-column", {
              key: "path",
              attrs: {
                width: "auto",
                label: "路径",
                align: "left",
                prop: "path",
              },
            }),
            _c("el-table-column", {
              key: "owner",
              attrs: {
                width: "auto",
                label: "owner",
                align: "left",
                prop: "owner",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }